import { render, staticRenderFns } from "./tel.vue?vue&type=template&id=108644fe"
import script from "./tel.vue?vue&type=script&lang=js"
export * from "./tel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports